export const getLeasingPhoneLineExceptionState = (): boolean => {
  const phoneLinesExceptionEnd = new Date("2025-04-16 23:59:59 GMT+0100");
  const currentDateTime = new Date();
  const displayPhoneLineExceptionState =
    currentDateTime <= phoneLinesExceptionEnd;

  return displayPhoneLineExceptionState;
};
